import { shallowEqual, useSelector } from 'react-redux'

import BrandFansAudienceInsightsTrigger from '@components/BrandFans/AudienceInsights/Trigger'
import { IApplicationState } from '@store'
import { selectIdentityAudienceInsightsLink, selectIdentityCreatorBioLink } from '@store/brandFans'
import { Container } from '@tribegroup'
import { InfluencerIdentityRowViewBio } from './ViewBio'

interface IProps {
  identityId: number
  brandFanMemberId?: number
  brandFanGroupId?: number
}

const BrandFanInfluencerIdentityRowLabels: React.FC<IProps> = ({
  identityId,
  brandFanGroupId,
  brandFanMemberId,
}) => {
  const { creatorBioLink, hasAudienceInsights } = useSelector((state: IApplicationState) => ({
    hasAudienceInsights: selectIdentityAudienceInsightsLink(state, identityId),
    creatorBioLink: selectIdentityCreatorBioLink(state, identityId),
  }), shallowEqual)
  return (
    <Container flexStart gap={0.75}>
      {hasAudienceInsights && (
        <BrandFansAudienceInsightsTrigger
          identityId={identityId}
          brandFanGroupId={brandFanGroupId}
          brandFanMemberId={brandFanMemberId}
        />
      )}
      {Boolean(creatorBioLink) && (
        <InfluencerIdentityRowViewBio href={creatorBioLink!.href} method={creatorBioLink!.method} />
      )}
    </Container>
  )
}

export { BrandFanInfluencerIdentityRowLabels }
export default BrandFanInfluencerIdentityRowLabels
